<template>
  <div>
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="单位级别" name="vipCompany_level"></el-tab-pane>

      <el-tab-pane label="单位分类" name="vipCompany_sort"></el-tab-pane>
    </el-tabs>
    <router-view></router-view>
  </div>

</template>

<script>
    export default {
      // name: "level_sort",
      data() {
        return {
          activeName: 'vipCompany_level'
        };
      },
      methods: {
        handleClick(tab, event) {
          this.$router.push(this.activeName)
        }
      },
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/vipCompany/level_sort.vue